export default __webpack_public_path__ + "static/media/courseBg4.da64bb9d.png";